import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { t } from 'services/translation';
import $ from 'jquery';
import classnames from 'classnames';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';
import AboutPropTypesMixin from './prop_types_mixin';
import CustomFields from './custom_fields';
import Footer from './footer';

const About = createReactClass({
  displayName: 'TourPage-About',
  mixins: [AboutPropTypesMixin],

  propTypes: {
    title: PropTypes.node.isRequired,
    locationAndContactNode: PropTypes.node,
  },

  getDefaultProps() {
    return {
      locationAndContactNode: <div />,
    };
  },

  getInitialState() {
    return {
      isDescriptionTruncated: true,
    };
  },

  componentDidMount() {
    const fullHeight = $(this.refs.fullDescriptionHidden).height();
    const truncatedHeight = $(this.refs.description).height();

    /* We want to hide the "More" link by default if the truncated version (6 lines)
     * is enough to show the full text.
     * To do that we need a hidden div with the full size in order to compare,
     * because 6 lines is calculated in em and will not always be the same. */
    if (truncatedHeight >= fullHeight) {
      this.setState({ isDescriptionTruncated: false });
    }
  },

  _descriptionToggleLinkClicked(e) {
    e.preventDefault();
    this.setState({
      isDescriptionTruncated: !this.state.isDescriptionTruncated,
    });
  },

  _description() {
    return {
      __html: this.props.description,
    };
  },

  _renderDescriptionToggleLink() {
    return (
      <div className="TourPage-About-description-more">
        <button
          type="button"
          className="link brand-color"
          onClick={this._descriptionToggleLinkClicked}
          onKeyDown={(e) =>
            isActionKey(e.key) && this._descriptionToggleLinkClicked(e)
          }
        >
          {t('MORE')} <i className="af-angle-down-ar brand-color" />
        </button>
      </div>
    );
  },

  render() {
    const descriptionClasses = classnames('TourPage-About-description', {
      collapsed: !this.state.isDescriptionTruncated,
    });
    return (
      <div className="TourPage-About tour-section">
        {this.props.title}
        <div className="TourPage-About-tagline tour-section-title">
          {this.props.tagline}
        </div>

        {this.props.locationAndContactNode}
        <div className={descriptionClasses} ref="description">
          <div dangerouslySetInnerHTML={this._description()} />
          <CustomFields customFields={this.props.custom_fields} />
          {this.props.footer && <Footer text={this.props.footer} />}
        </div>

        <div
          className="TourPage-About-description collapsed hidden"
          ref="fullDescriptionHidden"
        >
          <div dangerouslySetInnerHTML={this._description()} />
          <CustomFields customFields={this.props.custom_fields} test="test" />
          <Footer text={this.props.footer} />
        </div>

        {this.state.isDescriptionTruncated
          ? this._renderDescriptionToggleLink()
          : null}
      </div>
    );
  },
});

export default About;
